<template lang="pug">
    .home
      .landing.p-0
        .top-hack
        VueSlickCarousel.h-100(autoplay, :autoplaySpeed="6000", lazyLoad="true")
          .home-banner(v-for="banner in banners", :key="banner", :style="{'background-image': `url(${banner})`}")
      section
        .container
          .row.text-center
            .col-md-6.pb-5
              h1 BUY OR RENT ART
              img.illustration.pb-3(src="@/assets/images/illustrations/home_buy.svg", alt="art buying illustration")
              p Discover a unique collection of both emerging and established local artists, and explore our exclusive selection of carefully curated pieces.
              b-button.btn-light(:to="{name: 'gallery'}") BROWSE COLLECTION
            .col-md-6.pb-5
              h1 SIGN UP AS ARTIST
              img.illustration.pb-3(src="@/assets/images/illustrations/home_artist.svg", alt="artist signup illustration")
              p
                | Are you an artist looking to showcase and sell your work?
                | Apply to join Wall and connect with a growing network of art collectors
              b-button.btn-light(:to="{name: 'artist-register'}") ARTIST SIGN-UP
      section.p-0
        .container-fluid
          .row
            .col-md-6.text-center.p-3(v-for="category in categories", :key="category.title")
              router-link(:to="category.to").cat-link
                .preview.mb-2(:style="{'background-image': `url(${category.img})`}")
                span {{ category.title.toUpperCase() }}
      section.bg-alt-alt
        .container.p-5
          .row
            .col-0.col-md-3
            .col-md-3.center-xy.m-0
              img.d-none.d-md-block.logo-tilt(src="@/assets/images/branding/logo_icon_dark_side.svg", alt="Wall collective logo")
            .col-md-6.text-light
              h1.h-alt WHAT'S ON YOUR WALL?
              p.accent
                | We believe it should be unique, it should be local and it should be an investment.
                | Most of all we believe it should evoke a response.
                | The culmination of these beliefs underpin what we do, and why we created The Wall Collective.
              p
                | We are a fine art marketplace with a simple objective -
                | providing an easily accessible and seamless platform, connecting art collectors with both established and aspirational artists.
                | We aim to make premium art more accessible, flexible and affordable to the public. By pioneering a leasing framework locally,
                | and offering a completely integrated experience for purchasing, collecting and promoting art -
                | our diverse selection is adaptable to cater for all your bespoke creative needs.
      section.section-dark
        b-container.text-center
          content-loader(:height="7", v-if="alert.loading")
          VueSlickCarousel(v-else-if="artists && artists.length > 0", dots, autoplay, :autoplaySpeed='3000')
            .container.mt-3(v-for='artist in artists', :key='artist.id')
              .row
                .col-md-8
                  h2 {{ `FEATURED ARTIST  :   ${artist.name.toUpperCase()}` }}
                  div.w-100.py-3
                    b-button.piece.mx-1(v-for="piece in artist.art", :key='piece.id', :to="{name: `Piece`, params: { pieceId: piece.id, pieceTitle: kebabMe(piece.title) }}", :style="{'background-image': `url(${piece.thumbnail_url})`}", :aria-label="kebabMe(piece.title)")
                .col-md-4.center-xy
                  p {{ artist.bio }}
                  b-button.btn-outline-light(:to="{ name: 'gallery', query: { artist: artist.id} }") VIEW COLLECTION
          nothing(v-else="", text="NO FEATURED ARTISTS")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  metaInfo() {
    return { title: 'Wall Collective fine arts marketplace' };
  },
  name: 'Home',
  components: {
    VueSlickCarousel,
  },
  mixins: [standardMix],
  data() {
    return {
      artists: [],
      banners: [
        'https://ams3.digitaloceanspaces.com/wall.res/resources/backgrounds/banner_1.webp',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/backgrounds/banner_2.webp',
        'https://ams3.digitaloceanspaces.com/wall.res/resources/backgrounds/banner_3.webp',
        // 'https://ams3.digitaloceanspaces.com/wall.res/resources/backgrounds/banner_5.jpg',
      ],
      categories: [
        {
          title: 'Illustration',
          to: { name: 'gallery', query: { form: 'illustration' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/resources/images/link_illustration.webp',
        },
        {
          title: 'Painting',
          to: { name: 'gallery', query: { form: 'painting' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/resources/images/link_painting.webp',
        },
        {
          title: 'Print',
          to: { name: 'gallery', query: { form: 'print' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/resources/images/link_print.webp',
        },
        {
          title: 'Photography',
          to: { name: 'gallery', query: { form: 'photography' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/resources/images/link_photography.webp',
        },
      ],
      art: [
        {
          id: 1,
          title: 'Abstract',
          to: { name: 'gallery', params: { form: 'painting', style: 'abstract' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/abstract.jpg',
        },
        {
          id: 2,
          title: 'Pop Art',
          to: { name: 'gallery', params: { style: 'pop-art' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/pop.jpg',
        },
        {
          id: 3,
          title: 'Fine Arts',
          to: { name: 'gallery', params: { style: 'fine-art' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/fine.jpg',
        },
        {
          id: 4,
          title: 'Photography',
          to: { name: 'gallery', params: { form: 'photography' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/photography.jpg',
        },
        {
          id: 7,
          title: 'Portraits',
          to: { name: 'gallery', params: { subject: 'portrait' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/portrait.jpg',
        },
        {
          id: 6,
          title: 'Sculptures',
          to: { name: 'gallery', params: { form: 'sculpture' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/sculpture.jpg',
        },
        {
          id: 5,
          title: 'Drawings',
          to: { name: 'gallery', params: { form: 'drawing' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/drawing.jpg',
        },
        {
          id: 8,
          title: 'Oil Paintings',
          to: { name: 'gallery', params: { form: 'painting', medium: 'oil' } },
          img: 'https://ams3.digitaloceanspaces.com/wall.res/content/oil.jpg',
        },
      ],
    };
  },
  async created() {
    try {
      this.loading();
      // TEMP Only loading art for logged in user
      this.artists = await apiService.getArtists({ is_featured: true });
      this.clear();
    } catch (error) {
      this.error('Could not retrieve artists');
    }
  },
};
</script>

<style lang="scss" scoped>
h2{
      // font-family: Belleza !important;
    }
  .landing {
    .top-hack {
      // border-bottom: 1px solid rgba(black, 0.3);
      position: absolute;
      left: 0;
      top: -2px;
      width: 100%;
      background-color: white;
      height: 2px;
    }
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // height: 60vh;
    // @include desktop {

    //   height: 80vh;
    // }
    height: 80vh;
    background-color: black;

    .content {
      z-index: 1;
    }
    .home-banner {
      width: 100%;
      // height: 100%;
      height: 81vh;
      background-position: center;
      background-size: cover;
      background-repeat: none;
    }
    .bg {
      z-index: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-position: center;
      background-size: cover;
      background-repeat: none;
      background-image: url('../../assets/images/backgrounds/cover.jpg');
      // opacity: 0.7;
    }
  }

  .illustration {
    height: 200px;
  }

    .logo-tilt {
      height: 250px;
    }
    .thumbnail {
      height: 200px;
      max-width: 31%;
    }
     .cat-link {
      .preview {
        height: 200px;
        min-height: 200px;
        @include desktop {
          height: 50vh;
        }
          background-image: url('../../assets/images/backgrounds/cover.jpg');
          background-size: cover;
        }

      .overlay {
        cursor: pointer;
        @include cover;
        background-color: rgba(white, 0.2);
        opacity: 1;
        transition: ease-in 0.5s all;
        &:hover {
          color: white !important;
          background-color: rgba(#EFE7DB, 0.5);
        }
      }
    }
    .piece {
      width: 30%;
      // aspect-ratio: 1 / 1;
      padding-top: 30%;
      background-size: cover;
      background-position: center;
    }
    // .piece {
    //   position: relative;
    //   .thumbnail {
    //     width: 100%;
    //   }
    //   .overlay {
    //     @include cover;
    //     background-color: rgba(black, 0.5);
    //     opacity: 1;
    //     transition: ease-in 0.5s all;
    //     &:hover {
    //       opacity: 0;
    //     }
    //   }
    // }
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue